module.exports = __webpack_public_path__ + "img/八公桥镇.b9f70138.png";